import { useEffect } from 'react';

import '@syncfusion/ej2-react-inplace-editor/styles/inplace-editor/material.css';
import 'components/ProviderData/IpaAdministration/organisms/IpaAdministration.css';

type IpaAdministrationDetailViewMSODetailsProps = {
    mso: Record<string, any>;
    fetchMso: any;
};

function IpaAdministrationDetailViewMSODetails(props: IpaAdministrationDetailViewMSODetailsProps) {
    useEffect(() => {
        if (Object.keys(props.mso).length === 0) {
            props.fetchMso();
        }
    }, []);

    return (
        <div>
            <div className='labelInputWrap'>
                <label className='customLabel'>
                    <b className='boldElementStyle'>MSO Name</b>
                    <b>:</b>
                </label>
                <span className='customInputField paddingRight'>{props?.mso?.name}</span>
            </div>

            <div className='labelInputWrap'>
                <label className='customLabel'>
                    <b className='boldElementStyle'>Address</b>
                    <b>:</b>
                </label>
                <span className='customInputField paddingRight'>{props?.mso?.address1}</span>
            </div>

            <div className='labelInputWrap'>
                <label className='customLabel'>
                    <b className='boldElementStyle'>Suite/Bldg/No</b>
                    <b>:</b>
                </label>
                <span className='customInputField paddingRight'>{props?.mso?.address2}</span>
            </div>

            <div className='labelInputWrap'>
                <label className='customLabel'>
                    <b className='boldElementStyle'>City</b>
                    <b>:</b>
                </label>
                <input
                    className='customInputField paddingRight'
                    type='text'
                    defaultValue={props?.mso?.city ?? ''}
                />
            </div>

            <div className='labelInputWrap'>
                <label className='customLabel'>
                    <b className='boldElementStyle'>State</b>
                    <b>:</b>
                </label>
                <input
                    className='customInputField paddingRight'
                    type='text'
                    defaultValue={props?.mso?.state ?? ''}
                />
            </div>

            <div className='labelInputWrap'>
                <label className='customLabel'>
                    <b className='boldElementStyle'>Zip</b>
                    <b>:</b>
                </label>
                <input
                    type='text'
                    defaultValue={props?.mso?.zipCode ?? ''}
                    className='customInputField paddingRight'
                />
            </div>

            <div className='labelInputWrap'>
                <label className='customLabel'>
                    <b className='boldElementStyle'>Phone / Fax</b>
                    <b>:</b>
                </label>
                <span className='customInputField paddingRight'>{props?.mso?.phone}</span>
            </div>

            <div className='labelInputWrap'>
                <label className='customLabel'>
                    <b className='boldElementStyle'>Email</b>
                    <b>:</b>
                </label>
                <input
                    type='text'
                    defaultValue={props?.mso?.email ?? ''}
                    className='customInputField paddingRight'
                />
            </div>

            <div className='labelInputWrap'>
                <label className='customLabel'>
                    <b className='boldElementStyle'>Notes</b>
                    <b>:</b>
                </label>
                <span className='customInputField paddingRight'>{props?.mso?.notes}</span>
            </div>
        </div>
    );
}

export default IpaAdministrationDetailViewMSODetails;
